/* Ajustes propios de Ca Fuster sobre las filas que Loop inyecta en el carrito.
   Fichero nuestro: las reinstalaciones de los snippets de Loop no lo tocan.
   1) Reagrupa imagen y nombre en la misma celda: la tabla del tema tiene 3 columnas
      (producto / cantidad / total) y Loop pinta 4 celdas, lo que empujaba el nombre a un lado.
   2) En móvil, junta papelera y precio en la última columna (alineada con la cabecera "Total").
   3) Traduce el título del descuento que Loop genera en inglés ("bundle discount"). */
(function () {
	var TEXTS = { 'bundle discount': 'Descuento del pack' };
	var isEs = (document.documentElement.lang || '').toLowerCase().indexOf('es') === 0;

	function mergeMediaAndDetails() {
		var rows = document.querySelectorAll('.LOOP_cafuster_bundles tr.cart-item:not([data-cf-merged])');
		for (var i = 0; i < rows.length; i++) {
			var tr = rows[i];
			var media = tr.querySelector('.cart-item__media');
			var details = tr.querySelector('.cart-item__details');
			if (!media || !details) continue;
			var wrap = document.createElement('div');
			wrap.className = 'cart-item__merged';
			var mediaBox = document.createElement('div');
			mediaBox.className = 'cart-item__merged-media';
			while (media.firstChild) mediaBox.appendChild(media.firstChild);
			var textBox = document.createElement('div');
			textBox.className = 'cart-item__merged-text';
			while (details.firstChild) textBox.appendChild(details.firstChild);
			wrap.appendChild(mediaBox);
			wrap.appendChild(textBox);
			details.appendChild(wrap);
			media.parentNode.removeChild(media);
			tr.setAttribute('data-cf-merged', '1');
		}
	}

	/* En móvil la cabecera tiene 2 columnas (producto / total) y la celda de cantidad se oculta:
	   copiamos el botón de eliminar a la celda del precio. El clic lo gestiona Loop por delegación
	   (data-bundle-ref), así que la copia funciona igual que el original. */
	function addMobileTrash() {
		var rows = document.querySelectorAll('.LOOP_cafuster_bundles tr.cart-item:not([data-cf-trash])');
		for (var i = 0; i < rows.length; i++) {
			var tr = rows[i];
			var btn = tr.querySelector('.cart-item__quantity .loop-remove-bundle-btn');
			var total = tr.querySelector('.cart-item__totals.small-hide');
			if (!btn || !total) continue;
			var flex = document.createElement('div');
			flex.className = 'cf-totals-flex';
			var copy = document.createElement('span');
			copy.className = 'cf-trash-mobile';
			copy.appendChild(btn.cloneNode(true));
			flex.appendChild(copy);
			while (total.firstChild) flex.appendChild(total.firstChild);
			total.appendChild(flex);
			tr.setAttribute('data-cf-trash', '1');
		}
	}

	function translate(root) {
		var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
		var node;
		while ((node = walker.nextNode())) {
			var key = node.nodeValue.trim().toLowerCase();
			if (TEXTS[key]) node.nodeValue = node.nodeValue.replace(/\S[\s\S]*\S|\S/, TEXTS[key]);
		}
	}

	function run() {
		mergeMediaAndDetails();
		addMobileTrash();
		if (!isEs) return;
		var scope = document.querySelectorAll('.discounts, .discounts__discount');
		for (var i = 0; i < scope.length; i++) translate(scope[i]);
	}

	var timer;
	new MutationObserver(function () {
		clearTimeout(timer);
		timer = setTimeout(run, 50);
	}).observe(document.documentElement, { childList: true, subtree: true });
	run();
})();
